type EventName = "expectation_preview_clicked" | "data_source_selected" | "data_quality_issue_selected"
 | "survey dismissed" | "survey sent" | "scroll_depth" | "feedback_yes" | "feedback_no";

const posthogCapture = (eventName: EventName, data: Record<string, string>) => {
    window.posthog.capture(`gallery.${eventName}`, data);
}

const posthog = (eventName: EventName, data: Record<string, string>) => {
    window.posthog.capture(eventName, data);
}

export { posthogCapture, posthog }
